export { default } from './ChannelSectionGate';
